import { Injectable, Injector } from "@angular/core";
import { ServerService } from "src/services/server.service";
import { Act } from "./act";
import { Actions } from "./enum/actions";
import { AppViewStates } from "./enum/app-view-states";
import { OperationParam } from "./enum/operation-param";
import { TaskTrackerItemState } from "./enum/task-tracker-item-state";
import { Model } from "./model";
import { TaskTrackerSubItemActionParam } from "./types/task-tracker/task-tracker-sub-item-action-param";
import { TaskTrackerItemSubItem } from "./types/task-tracker/task-tracker-item-sub-item";

/**Действия Трэкера */
@Injectable({
  providedIn: 'root'
})
export class ActTracker {
  constructor(private model: Model
    , private act: Act
    , private server: ServerService
    ) {
  }

  /**
   * Выполнить действие
   * @param action действие
   * @param data данные
   */
  do(action: Actions, data: any = null) {
    console.log('action', Actions[action]);
    switch (action) {
      /**загрузка данных задачи */
      case Actions.trackerLoadItem: {        
        this.server.post('TaskTrackerItem', {
          operation: OperationParam.Get
          , noteId: this.model.traskItemNoteId
        }).subscribe((res)=>{
          console.log('get res',res);
          if(res?.Res){
            let itemObj = JSON.parse(res.Res);
            Object.assign(this.model.taskItem, itemObj);
            this.model.trackerItemMainTextInnerHtml = this.model.taskItem.mainText;
          }else{
            this.model.taskItem.mainText = "<b>Задача</b><br><br>";
            this.model.trackerItemMainTextInnerHtml = this.model.taskItem.mainText;
          }
        });
        }
        break;

      /**изменения состояния пункта задачи */
      case Actions.trackerChangeSubItemState: {
        let param = <TaskTrackerSubItemActionParam>data;
        console.log('trackerChangeSubItemState',param);
        if(param && param.subItem && param.state){
          param.subItem.state = param.state;
          this.do(Actions.trackerOnChangeSubItems, param.subItem);
        }
        this.do(Actions.trackerSaveItem);
        }
        break;

      /**применение изменений при изменении состояний пунктов задачи*/
      case Actions.trackerOnChangeSubItems: {
        let state: TaskTrackerItemState;
        if(data){
          state = (<TaskTrackerItemSubItem>data).state;
        }
        else{
          state = TaskTrackerItemState.Removed;
        }

        switch(state){
          case TaskTrackerItemState.Done:
            if(this.model.taskItem.subItems.every(el=>el.state==TaskTrackerItemState.Done)){
              this.model.taskItem.finalMessageHidden = false;
              this.do(Actions.trackerChangeItemState, TaskTrackerItemState.Done);
            }
          break;
          default:
            if(this.model.taskItem.state == TaskTrackerItemState.Done 
                && !this.model.taskItem.subItems.every(el=>el.state==TaskTrackerItemState.Done)){
              this.do(Actions.trackerChangeItemState, TaskTrackerItemState.NotActive);
            }
      }}
      break;

      /**изменение состояния задачи */
      case Actions.trackerChangeItemState: {
        let param = <TaskTrackerItemState>data;
        this.model.taskItem.state = param;
      }
      break;

      /**действия с пунктом задачи */
      case Actions.trackerSubItem: {
        let param = <TaskTrackerSubItemActionParam>data;
        switch(param.operation){
          case OperationParam.Add:
            let pos = 0;
            this.model.taskItem.subItems.forEach((n)=>{ if(n.position>pos)pos=n.position; });      
            this.model.taskItem.subItems.push({ 
              name: param.name ?? '',
              position: ++pos, 
              state: TaskTrackerItemState.NotActive,
              menuOpened: false,
              edit: false,
              deleted: false});
            this.model.taskItem.mainText += `<br><b>${param.name}</b><br>`;
            this.model.trackerItemMainTextInnerHtml = this.model.taskItem.mainText;
            this.do(Actions.trackerOnChangeSubItems);
            this.do(Actions.trackerSaveItem);
            break;

          case OperationParam.Update:
            this.model.taskItem.subItems.sort((a, b) => a.position-b.position);
            //this.do(Actions.trackerOnChangeSubItems);            
            this.do(Actions.trackerSaveItem);
            break;

          case OperationParam.Del:
            if(param.subItem)
              this.model.taskItem.subItems.splice(this.model.taskItem.subItems.indexOf(param.subItem), 1);
            this.do(Actions.trackerOnChangeSubItems);
            this.do(Actions.trackerSaveItem);
            break;
        }
      }
      break;

      /**сохранение задачи */
      case Actions.trackerSaveItem: {
        this.model.taskItem.subItems.forEach((it)=>{
          it.menuOpened = false;
          it.edit = false;
        });
        // localStorage.setItem('taskItem', JSON.stringify(this.model.taskItem));
        this.server.post('TaskTrackerItem', {
              operation: OperationParam.Update
              , dataJson: JSON.stringify(this.model.taskItem)
              , noteId: this.model.traskItemNoteId
            }).subscribe(()=>{});
        }
        break;
    }
  }
}
